import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-multa-renainf',
  templateUrl: './consulta-multa-renainf.component.html',
  styleUrls: ['./consulta-multa-renainf.component.scss']
})
export class ConsultaMultaRenainfComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msg;

  @Input() token = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.setStatus();
  }

  setStatus(){
    if(this.consulta && this.consulta.lista && this.consulta.lista.length > 0) {
      this.status = 'warning';
      this.statusMsg = 'CONSTAM OCORRENCIAS';
    }else{
      this.status = 'success';
      this.statusMsg = 'NÃO CONSTAM OCORRENCIAS';
    }
  }

}
